<template>
  <div>
    <!-- {{ form }}  -->
    <div v-if="form.type == 1 && disabled">
      <Textarea-Form
        :record="record"
        :label="form.label"
        :init="form.init"
        :rules="convertRule(form.rule)"
        :disabled="disabledCheck(form.rule)"
      ></Textarea-Form>
    </div>
    <div v-else-if="form.type == 2">
      <!-- {{ form }} -->
      <Selectbox-Form
        :record="record"
        :label="form.label"
        :init="form.init"
        :selectbox="form.selectbox"
      ></Selectbox-Form>
    </div>
    <div v-else-if="form.type == 3">
      <Calender-form :record="record" :label="'日付選択'"></Calender-form>
    </div>
    <div v-else-if="form.type == 7">
      <Checkbox-Form
        :record="record"
        :label="form.label"
        :init="form.init"
        :checkbox="form.checkbox"
      ></Checkbox-Form>
    </div>
    <div v-else-if="form.type == 8">
      <Textbox-Form
        :record="record"
        :label="form.label"
        :init="form.init"
        :rows="Number(form.size)"
        :rules="convertRule(form.rule)"
        :disabled="disabledCheck(form.rule)"
      ></Textbox-Form>
    </div>
    <div v-else-if="form.type == 9">
      <Fileupload-Form :label="form.label"></Fileupload-Form>
    </div>
    <div v-else-if="form.type == 10">
      <Image-form :width="form.width" :height="form.height"></Image-form>
    </div>
    <div v-else-if="form.type == 11">
      <!--{{ form }}-->
      <Textboxplus-Form
        :label="form.label"
        :init="form.init"
        :rules="convertRule(form.rule)"
        :value="form.value"
      ></Textboxplus-Form>
    </div>
    <div v-else-if="form.type == 12">
      <!--{{ form }}-->
      <Worktime-Form></Worktime-Form>
    </div>
    <div v-else-if="form.type == 14">
      <AnyCheckbox-Form
        :label="form.label"
        :init="form.init"
        :json="form.checkbox"
      ></AnyCheckbox-Form>
    </div>
    <div v-else-if="form.type == 15">
      <Timeimput-form :rule="form.rule" :label="form.label"></Timeimput-form>
    </div>
    <div v-else-if="form.type == 16">
      <Button-form
        :record="record"
        :label="form.label"
        :init="form.init"
        :rule="form.rule"
        :color="form.color"
      ></Button-form>
    </div>
    <div v-else-if="form.type == 18">
      <Employee-Param
        :record="record"
        :label="form.label"
        :init="form.init"
        :rule="form.rule"
        :color="form.color"
      ></Employee-Param>
    </div>
  </div>
</template>

<script>
import TextareaForm from "./FormParts/textarea";
import SelectboxForm from "./FormParts/selectbox";
import CalenderForm from "./FormParts/calender2";
import CheckboxForm from "./FormParts/checkbox";
import TextboxForm from "./FormParts/textbox";
import FileuploadForm from "./FormParts/fileupload";
import ImageForm from "./FormParts/imageForm";
import TextboxplusForm from "./FormParts/textboxplus";
import WorktimeForm from "./FormParts/worktime";
import AnyCheckboxForm from "./FormParts/anycheckbox";
import TimeimputForm from "./FormParts/timeimput";
import ButtonForm from "./FormParts/button";
import EmployeeParam from "./FormParts/EmployeeParam";
export default {
  props: {
    form: Object,
  },
  data() {
    return {
      disabled: false,
      record: {},
    };
  },
  components: {
    TextareaForm,
    SelectboxForm,
    CalenderForm,
    CheckboxForm,
    TextboxForm,
    FileuploadForm,
    ImageForm,
    TextboxplusForm,
    WorktimeForm,
    AnyCheckboxForm,
    TimeimputForm,
    ButtonForm,
    EmployeeParam,
  },
  async mounted() {
    //初期処理
    await this.InitRecord();
  },
  methods: {
    async InitRecord() {
      //console.log(this.form);
      let rules = [];
      if (this.form.type == 1) {
        rules = this.form.rule.split(",");
        if (rules[5] != "hide") {
          //不透明は表示しない
          this.disabled = true;
        }
      }
      switch (this.form.type) {
        case 1:
        case 2:
        case 7:
        case 8:
        case 9:
        case 11:
        case 14:
        case 15:
        case 18:
          this.record = {
            value: this.form.init,
            form_id: this.form.form_id,
            init: this.form.init,
            form_type: this.form.type,
          };
          break;
        case 3:
          this.record = {
            value: "日付欄",
            form_id: this.form.form_id,
            form_type: this.form.type,
          };
          break;
        case 10:
          this.record = {
            width: String(this.form.width),
            height: String(this.form.height),
            form_type: this.form.type,
          };
          break;
        case 16:
          this.record = {
            value: this.form.init,
            form_id: this.form.form_id,
            form_type: this.form.type,
            disabled: false,
          };
          break;
        case 17: //サブページ
          break;
        default:
          console.log("another type:", this.form.type);
      }
    },
    convertRule(rule) {
      let str = rule.split(",");
      //
      let rules = {
        required: (value) => !!value || "必須項目です",
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ入力可能です。";
        },
        alphanumeric: (value) => {
          return (
            /^[a-zA-Z0-9\n]*$/.test(value) || "英数字+改行のみ入力可能です。"
          );
        },
      };
      //
      let ans = [];
      if (str[0] != "") {
        ans.push(rules.required);
      }
      if (str[1] == "1") {
        ans.push(rules.numonly);
      } else if (str[1] == "2") {
        ans.push(rules.alphanumeric);
      }
      return ans;
    },
    disabledCheck(rules) {
      let rule = rules.split(",");
      if (rule[2] == "required") {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
/*@import "../../../../css/styles.css";*/
</style>
